<template>
	<div class="next-opponent">
	
		<div class="characters">
			<div v-for="character in characters" class="character-wrap" :class="{ dead: character.dead, next: next && next.slug === character.slug }" :key="character.slug">
				<character :character="character" />
				<!-- <div v-if="character.score" class="score-value">{{ character.score }}</div> -->
			</div>
		</div>
		
		<template v-if="game.status === 'starting' || fight.status === 'next-opponent'">
			<transition name="opponent">
				<div v-show="next" class="title">
					<span v-if="fight.status === 'next-opponent'">Next opponent</span>
					<span v-if="game.status === 'starting'">First fight</span>
				</div>
			</transition>

			<div class="opponent">
				<transition name="opponent">
					<div v-if="next" class="card-wrap">
						<character :character="next" />
					</div>
				</transition>
			</div>

			<div class="prevent-over"></div>
		</template>
		
		<template v-if="game.status === 'ended'">
			<div class="title">
				<span v-if="game.wins.length === 17">Victory!</span>
				<span v-else>Game over</span>
			</div>
			<div class="description">Your score</div>

			<div class="score">
				<span>{{ score }}</span>
			</div>

			<div class="button" v-hammer:tap="() => back()">Retour</div>
		</template>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import data_characters from '@/data/characters'
import Character from '@/components/game/character'
import Sounds from '@/js/sounds'

export default {
	name: 'next-opponent',
	data() {
		return {
			next: null
		}
	},
	computed: {
		...mapGetters([ 'game', 'fight', 'score' ]),
		characters() {
			return data_characters
				.filter((c) => !c.playable)
				.map((c) => {
					// return { ...c, score: (this.game.wins.find((w) => w.slug === c.slug) || { score: 0 }).score }
					return { ...c, dead: this.game.wins.findIndex((w) => w.slug === c.slug) > -1 }
				})
		}
	},
	methods: {
		back() {
			Sounds.play('button')
			this.$store.commit('EDIT_APP_STATE', { screen: 'home' })
			// this.$store.dispatch('init_game')
		}
	},
	mounted() {
		if (this.game.status === 'starting' || this.fight.status === 'next-opponent') {
			setTimeout(() => {
				Sounds.play('versus')
			}, 500)
			setTimeout(() => {
				this.next = this.fight.opponent
			}, 750)
		}
	},
	components: { Character }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'



.next-opponent
	absolute 0
	background-color dark
	flex center center
	flex-direction column
	color light
	transition 0.25s easeOutQuart
	&.next-opponent-enter
		opacity 0
		transform translateY(-40px)
	&.next-opponent-leave-to
		opacity 0
		transform translateY(40px)
	.characters
		position absolute
		left 0
		right 0
		top 64px
		flex center center
		.character-wrap
			width round(144px / 2.5)
			height round(200px / 2.5)
			margin 4px
			&.dead
				&:after
					content ''
					absolute 0px
					border-radius 8px
					background alpha(red, 15%) url('../../assets/img/red-dead.svg') center center no-repeat
					background-size 90%
				>>> .character
					.avatar
						border-color red
						.name
							color red
							opacity 1
			
			&.next
				>>> .character
					.avatar
						.name, .head
							opacity 1
			>>> .character
				width @width
				height @height
				.hearts
					display none
				.avatar
					border-color #484543
					.name
						position absolute
						left 50%
						top -28px
						right auto
						line-height 24px
						font-size 1.6rem
						white-space nowrap
						transform translateX(-50%)
						opacity 0.1
					.head
						opacity 0.1
						background-position center center
			.score-value
				position absolute
				left 0
				right 0
				top calc(100% + 8px)
				line-height 16px
				text-align center
				
	.title
		width 100%
		margin 0 0 80px 0
		text-align center
		font-size 6.4rem
		text-transform uppercase
		transition 0.2s easeOutQuart
		&.opponent-enter
			transform translateY(-24px)
			opacity 0
	.description
		width 100%
		margin 0 0 24px 0
		text-align center
		font-size 3.2rem
		opacity 0.5
	
	.opponent
		width card_width
		height card_height
		.card-wrap
			width card_width
			height card_height
			transition 0.2s easeOutQuart
			&.opponent-enter-active
				transition-delay 0.1s
			&.opponent-enter
				transform translateY(-24px) scale(1.2)
				opacity 0
	
	.score
		margin 0 0 96px 0
		height 80px
		width 80px
		line-height (@height + 4px)
		color dark
		text-align center
		font-size 4rem
		&:before
			content ''
			absolute 0
			background-color light
			transform rotate(45deg)
	
	.button
		height 64px
		padding 0 24px
		background-color light
		color dark
		line-height (@height + 6px)
		cursor pointer
		text-transform uppercase
		font-weight 700
		&:hover
			background-color darken(light, 10%)
		&:active
			background-color darken(light, 10%)
			transform translateY(2px)
		&:before, &:after
			content ''
			position absolute
			width 2px
			height 100%
			background-color light
		&:before
			left -8px
		&:after
			right -8px


</style>
